export default __webpack_public_path__ + "static/media/business.ed361178.png";